import axios from 'axios'
import {NotificationManager} from 'react-notifications'
import moment from 'moment'
import 'moment/locale/es'

class Trebus {

    // Use local API when running on localhost, preapi for pre-production, otherwise production
    url = window.location.hostname === 'localhost'
        ? 'http://localhost:8000/api'
        : window.location.hostname === 'preapp.bolebus.es'
            ? 'https://preapi.bolebus.es/api'
            : 'https://api.bolebus.es/api'

    constructor() {

        this.contextLoaded = false;

        // App version
        this.version = 'v1.18';

        console.log('API URL:', this.url);

        // Fix Spanish month names to ensure 'mayo' is displayed correctly
        this.fixSpanishMonthNames();
    }

    /**
     * Fix Spanish month names in Moment.js to ensure 'mayo' is displayed correctly
     * instead of 'mayonesa' for some users
     */
    fixSpanishMonthNames() {
        // Set the locale to Spanish
        moment.locale('es');

        // Define the correct month names in Spanish
        const correctMonths = [
            'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
            'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
        ];
        
        // Update the locale with the correct month names
        moment.updateLocale('es', {
            months: correctMonths
        });
        
        console.log('Spanish month names fixed in Moment.js');
    }

    /**
     * Llamar a API REST
     *
     *    * array params - Parámetros a enviar
     *    * array context - AppContext.
     *    * function success - Función de que todo_ ha ido bien.
     *    * function error - Función de que ha habido algún error..
     *
     * @param method
     * @param resource
     * @param p
     */
    api(
        method,
        resource,
        p = {}
    ) {
        // Get token
        const token = p.context && p.context.user ? p.context.user.api_token : '';
        console.log('API Call:', method, this.url + resource);
        if (p.params) console.log('Params:', p.params);

        // Create the request config
        const config = {
            method: method,
            url: this.url + resource,
            params: method === 'GET' ? p.params : null,
            data: method !== 'GET' ? p.params : null,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token ? `Bearer ${token}` : ''
            },
            timeout: 15000 // 15 seconds timeout (reduced from 30s)
        };

        console.log('Request config:', { 
            method: config.method, 
            url: config.url, 
            hasToken: !!token 
        });

        // Call API
        axios(config)
            .then(response => {
                console.log('API Response:', response.status);
                const r = response.data;
                
                // Call success or error
                if (r.error) {
                    console.error('API returned error:', r.error);
                    if (p.error) p.error(r);
                    else NotificationManager.error(r.error);
                } else {
                    if (p.success) {
                        console.log('API success, calling success callback');
                        p.success(r);
                    }
                }
            })
            .catch(error => {
                console.error('API Error:', error.message);
                
                // Format a user-friendly error message
                let errorMessage = 'Error de conexión al servidor';
                
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.error('Response error status:', error.response.status);
                    console.error('Response error data:', error.response.data);
                    
                    if (error.response.status === 401) {
                        errorMessage = 'Sesión expirada o no autenticado. Por favor, inicie sesión nuevamente.';
                        // Clear local storage to force re-login
                        localStorage.removeItem('token');
                    } else {
                        const errorData = error.response.data;
                        errorMessage = `Error ${error.response.status}: ${errorData.error || errorData.message || 'Error en la respuesta del servidor'}`;
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    console.error('No response received:', error.request);
                    errorMessage = 'No se recibió respuesta del servidor. Compruebe su conexión a internet.';
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.error('Request setup error:', error.message);
                    errorMessage = `Error en la configuración de la solicitud: ${error.message}`;
                }
                
                // Call error callback or show notification
                if (p.error) {
                    console.log('Calling error callback');
                    p.error({error: errorMessage});
                } else {
                    NotificationManager.error(errorMessage);
                }
            });
    }

    /**
     * Redireccionar
     *
     */
    go() {
        console.log('******************** Called trebus.go() whick is deprecated.')
    }

    wdName(wd) {
        switch (wd) {
            case 0:
                return 'Domingo';
            case 1:
                return 'Lunes';
            case 2:
                return 'Martes';
            case 3:
                return 'Miércoles';
            case 4:
                return 'Jueves';
            case 5:
                return 'Viernes';
            case 6:
                return 'Sábado';
            default:
        }
    }
}

export const tre = new Trebus();
